import { useContext, useEffect, useState } from 'react';
import { LayoutContext } from 'contexts';
import { FLOATING_PANEL_BAR_HEIGHT } from '../constants';
import useWindowHeight from './useWindowHeight';

const useFloatingPanelAnchors = (): number[] => {
  const layoutContext = useContext(LayoutContext);
  const [anchors, setAnchors] = useState<number[]>([0]);
  const innerHeight = useWindowHeight(0); // prevent android keyboard from pushing the panel off screen
  useEffect(() => {
    // if adjusting first anchor point, adjust map height in TourMapView/index as well
    setAnchors([
      innerHeight * 0.33,
      innerHeight * 0.66,
      innerHeight -
        layoutContext.topElementHeights.bbAssume +
        FLOATING_PANEL_BAR_HEIGHT,
    ]);
  }, [innerHeight, layoutContext.topElementHeights.bbAssume]);

  return anchors;
};

export default useFloatingPanelAnchors;
